import CheckIcon from "@mui/icons-material/CheckCircle";
import {
  Box,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  useMediaQuery,
} from "@mui/material";
import { styled, withTheme } from "@mui/styles";

import { NA } from "components/acronyms";
import { colors } from "theme";

const IncludedCell = () => (
  <TableCell>
    <Box component="span" className="sr-only" title="included" />
    <CheckIcon color="primary" style={{ display: "block", margin: "auto" }} />
  </TableCell>
);

const NotIncludedCell = () => <TableCell title="not included"></TableCell>;

export const OptionsTable = () => {
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.only("xs"));

  return (
    <TableContainer>
      <Table style={{ tableLayout: xs ? "auto" : "fixed" }}>
        <TableHead>
          <TableRow>
            <TableCell aria-label="option features"></TableCell>
            <TableCell>Assay Marketplace</TableCell>
            <TableCell>Assay Designer service</TableCell>
            <TableCell>Designer Pro service</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <FirstCell>Predesigned and functionally tested primers</FirstCell>
            <IncludedCell />
            <IncludedCell />
            <IncludedCell />
          </TableRow>
          <TableRow>
            <FirstCell>
              <Box component="i">De novo</Box> designs
            </FirstCell>
            <NotIncludedCell />
            <IncludedCell />
            <IncludedCell />
          </TableRow>
          <TableRow>
            <FirstCell>
              <Box component="i">In silico</Box> design review
            </FirstCell>
            <TableCell></TableCell>
            <TableCell>
              <Box component="i">De novo</Box> designs generated by Assay
              Designer with design report and expert review
            </TableCell>
            <TableCell>
              <Box component="i">De novo</Box> designs optimized via iterative
              testing
            </TableCell>
          </TableRow>
          <TableRow>
            <FirstCell>Functional testing</FirstCell>
            <NotIncludedCell />
            <NotIncludedCell />
            <IncludedCell />
          </TableRow>

          <TableRow>
            <FirstCell>Turnaround time</FirstCell>
            <TableCell>
              <Box
                component="ul"
                margin={0}
                style={{ listStyleType: "disc", listStylePosition: "inside" }}
              >
                <Box component="li">2 weeks domestic/ international</Box>
                <Box component="li">4 weeks EMEA</Box>
              </Box>
            </TableCell>
            <TableCell>4-6 weeks</TableCell>
            <TableCell>8-12 weeks</TableCell>
          </TableRow>
          <TableRow>
            <FirstCell>Minimum numbers of reactions</FirstCell>
            <TableCell>24</TableCell>
            <TableCell>24</TableCell>
            <TableCell>144</TableCell>
          </TableRow>
          <TableRow>
            <FirstCell>Maximum numbers of reactions</FirstCell>
            <TableCell>144</TableCell>
            <TableCell>
              <NA />
            </TableCell>
            <TableCell>
              <NA />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const TableCell = styled(withTheme(MuiTableCell))(({ theme }) => ({
  borderWidth: "0 1px 1px 0",
  borderStyle: "solid",
  borderColor: colors.grey[500],
  padding: "24px 16px 23px",
  [theme.breakpoints.down('md')]: {
    padding: "16px 16px 15px",
  },
  "&.MuiTableCell-head": {
    backgroundColor: theme.palette.primary.main,
    color: colors.white,
    letterSpacing: 0.5,
    fontSize: 18,
    lineHeight: "26px",
    fontWeight: 600,
    textAlign: "center",
    [theme.breakpoints.down('md')]: {
      padding: "16px 8px 15px",
    },
  },
  "&.MuiTableCell-body:not(.MuiTableCell-head)": {
    textAlign: "center",
  },
}));

const FirstCell = styled(
  withTheme((props) => <TableCell component="th" scope="row" {...props} />)
)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: colors.white,
  fontSize: 16,
  lineHeight: "23px",
  letterSpacing: 0.5,
  fontWeight: 400,
  textAlign: "left",
}));
